export const getAssetsStepStyles = () => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    gap: '32px',

    '& .title-item': {
      width: 'unset !important',
    },
  },
  'container-l': {
    width: 'calc(100% - 64px)',
  },
  imageExperience: {
    '& .image-experience-content': {
      minWidth: 'unset !important',
    },
  },
  formContainer: {
    width: '100%',
    '& .text-assets-collection-container': {
      width: 'auto',
    },
    '& .asset-group-name-section .error-string-wrapper': {
      right: 'unset !important',
      position: 'unset !important',
    },

    '& .text-input-container': {
      width: '100%',
    },
    '& .date-settings table': {
      width: 'unset !important',
    },
    '& .asset-group-enhance-ads-section': {
      '& .section-description': {
        marginBottom: '16px',
      },
    },
  },
  'formContainer-xxl': {
    width: '530px',
  },
  'formContainer-xl': {
    width: '430px',
  },
  previewerContainer: {
    '& > div': {
      top: 124,
    },
    flexGrow: '1',
  },
  'previewerContainer-l': {
    width: 'calc(100% - 64px)',
  },
  'previewerContainer-m': {
    width: 'calc(100% - 64px)',
  },
  'previewerContainer-s': {
    width: 'calc(100% - 64px)',
  },
  formHeader: {
    marginBottom: '24px',
  },
});
